export function formatCurrency(
  amount: string | number,
  currency = 'USD'
): string {
  const numericAmount = typeof amount === 'number' ? amount : Number(amount);
  const normalizedCurrency = String(currency || 'USD').trim().toUpperCase();

  if (!Number.isFinite(numericAmount)) {
    return `${String(amount)} ${normalizedCurrency}`.trim();
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: normalizedCurrency,
      currencyDisplay: 'symbol',
    }).format(numericAmount);
  } catch {
    return `${numericAmount.toFixed(2)} ${normalizedCurrency}`;
  }
}
